import React, { Component } from 'react'

class TableData extends Component {

    render() {
        let tableData

        if (Array.isArray(this.props.data[0])) {
            // If the table data is a list of lists then loop through the inner list to generate column data
            tableData = this.props.data.map((row, rowIndex) => {
                return (
                    <tr key={rowIndex}>
                        {
                            row.map((column, colIndex) => <td key={colIndex} id={rowIndex} >{column}</td>)
                        }
                    </tr>)
            })
        } else {
            // If the table data is a list of objects then iterate over each key in the object/ the keys in keysToSelect
            // and use the values of those properties to generate column data
            tableData = this.props.data.map((row, rowIndex) => {
                return (
                    <tr key={rowIndex}>
                        {
                            Object.keys(row).map((key) => {
                                if (!this.props.keysToSelect || this.props.keysToSelect.includes(key)) {
                                    return <td key={key}>{row[key]}</td>
                                } else {
                                    return null
                                }
                            })
                        }
                    </tr>)
            })
        }

        return (
            <tbody>{tableData}</tbody>
        )
    }
}

export default TableData